import React from 'react';
import { Card } from '../../../../../../../../CommonComponents/OPL/Card/Card';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { SERIES_COLORS } from '../../../../../../../../CommonComponents/OPL/charts/charts.constants';
import { ColumnChart } from '../../../../../../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart';
import { Dot } from '../../../../../../../../CommonComponents/OPL/Dot/Dot';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { colorsMap, useChart } from './useChart';

export const ChartPrint = () => {
  const { data } = useChart();

  if (!data) {
    return null;
  }

  const {
    chartSettings,
    series,
    categories,
    principalRetirementYear,
    spouseRetirementYear,
    principalName,
    spouseName,
    monteCarloHighRange,
    monteCarloMediumRange,
    monteCarloLowRange,
    principalLifeExpectancy,
    spouseLifeExpectancy,
  } = data;

  return (
    <Card display="flex" hasBorder p="24">
      <Box flexDirection="column" display="flex" justifyContent="space-between" flex="1">
        <Box width="100%">
          <ColumnChart
            series={series}
            categories={categories}
            yAxisType="percentage"
            customSettings={chartSettings}
          />
        </Box>

        <Box
          as="ul"
          display="flex"
          alignItems="center"
          justifyContent="center"
          p="24"
          css={({ theme }) => ({
            gap: theme.space['24'],
            minWidth: '300px',
          })}
        >
          <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
            <Box width="12px" height="12px" bg={colorsMap.green} />
            <Text fontSize="small" fontWeight={500} color="neutral.600">
              {monteCarloHighRange} Probability of Success
            </Text>
          </Box>

          <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
            <Box width="12px" height="12px" bg={colorsMap.yellow} />
            <Text fontSize="small" fontWeight={500} color="neutral.600">
              {monteCarloMediumRange} Probability of Success
            </Text>
          </Box>

          <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
            <Box width="12px" height="12px" bg={colorsMap.red} />
            <Text fontSize="small" fontWeight={500} color="neutral.600">
              {monteCarloLowRange} Probability of Success
            </Text>
          </Box>
        </Box>

        <Box
          as="ul"
          display="flex"
          alignItems="center"
          justifyContent="center"
          p="24"
          css={({ theme }) => ({
            gap: theme.space['24'],
            minWidth: '300px',
          })}
        >
          <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
            <Dot bg={SERIES_COLORS[2]} />
            <Text fontSize="small" fontWeight={500} color="neutral.600">
              {principalName}- Retirement - {principalRetirementYear}
            </Text>
          </Box>

          {spouseRetirementYear && (
            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Dot bg={SERIES_COLORS[0]} />
              <Text fontSize="small" fontWeight={500} color="neutral.600">
                {spouseName} - Retirement - {spouseRetirementYear}
              </Text>
            </Box>
          )}

          <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
            <Box width="12px" height="12px" bg={SERIES_COLORS[3]} />
            <Text fontSize="small" fontWeight={500} color="neutral.600">
              {principalName} - Life Expectancy - {principalLifeExpectancy}
            </Text>
          </Box>

          {spouseName && (
            <Box as="li" display="flex" css={({ theme }) => ({ gap: theme.space['12'] })}>
              <Box width="12px" height="12px" bg={SERIES_COLORS[1]} />
              <Text fontSize="small" fontWeight={500} color="neutral.600">
                {spouseName} - Life Expenctancy - {spouseLifeExpectancy}
              </Text>
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  );
};
